import { render, staticRenderFns } from "./booksCover.vue?vue&type=template&id=2072e1c1&scoped=true&"
import script from "./booksCover.vue?vue&type=script&lang=js&"
export * from "./booksCover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2072e1c1",
  null
  
)

export default component.exports